export default "__VITE_ASSET__C5K1G7RD__"